import React, { useState, useEffect, useRef } from 'react';
import { Table, Button, Select } from 'antd';
import { CloseCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import MultiTextInputBox from '../../../components/MultiTextInputBox';
import PropTypes from 'prop-types';
import styled from './styled';
import { handleFilterPopup } from './index';
const { styleAddFilter, styleRemoveFilter, flexEnd } = styled;
let count = 0;

const defaultProps = {
  listenFilters: null
};

const Filter = ({ listenFilters }) => {
  const filterTypes = [
    { id: 'alertId', name: 'Alert ID' },
    { id: 'runInstanceId', name: 'Run Instance ID' },
    { id: 'runInstanceExecutionId', name: 'Run Instance Execution ID' },
    { id: 'alertStatus', name: 'Review Status' },
    { id: 'alertQuality', name: 'Review Feedback' }
  ];
  const reviewFeedbackData = [
    { id: 'low', name: 'Low Quality' },
    { id: 'good', name: 'Good Quality' },
    { id: 'high', name: 'High Quality' }
  ];
  const reviewStatusData = [
    { id: 'Not Started', name: 'Not Started' },
    { id: 'In Progress', name: 'Work in Progress' },
    { id: 'Completed', name: 'Completed' }
  ];

  const columns = [
    {
      title: 'Filter',
      width: '15em',
      render: (args) => filterTemplate(args)
    },
    {
      title: 'Logic',
      width: '10em',
      render: (args) => logicTemplate(args)
    },
    {
      title: 'Items',
      width: '25em',
      render: (args) => itemsTemplate(args)
    },
    {
      title: '',
      render: (args) => (
        <CloseCircleOutlined
          onClick={handleRemoveFilter(args)}
          style={styleRemoveFilter}
        />
      )
    }
  ];

  const [data, setData] = useState([]);
  const [unUsedFilterOptions, setUnUsedFilterOptions] = useState([]);
  const [isDisable, setIsDisable] = useState(true);

  useEffect(() => {
    if (data?.length === 0) return;
    const isValid = data.every(({ item }) => Boolean(item?.val?.length));
    setIsDisable(!isValid);
  }, [data]);

  const filterTemplate = (dataObj) => {
    const { filter } = dataObj;

    // To remove used values from the filter options
    const filterSelectOptions = () => {
      const usedFIlterType = data?.map(({ filter }) => filter.val);
      const newfilterTypesList = filterTypes?.filter(
        ({ id }) => !usedFIlterType.includes(id)
      );
      setUnUsedFilterOptions(newfilterTypesList);
    };
    return (
      <Select
        onFocus={filterSelectOptions}
        placeholder="Select Filter"
        defaultValue={filter?.val}
        onChange={handleChangeFilter(dataObj)}
        style={{ minWidth: '99%' }}>
        {unUsedFilterOptions?.map(({ id, name }) => (
          <Option value={id}>{name}</Option>
        ))}
      </Select>
    );
  };

  const logicTemplate = ({ logic }) => {
    return (
      <Select defaultValue={logic?.val}>
        {logic?.data?.map(({ id, name }) => (
          <Option value={id}>{name}</Option>
        ))}
      </Select>
    );
  };

  const itemsTemplate = (dataObj) => {
    const { item } = dataObj;
    switch (item?.type) {
      case 'selectbox':
        return (
          <Select
            key={item?.val?.length} //To reset the element
            style={{ width: '99%' }}
            mode="multiple"
            defaultValue={item?.val}
            placeholder="Select Items"
            onChange={handelSelectItem(dataObj)}>
            {item?.data?.map(({ id, name }) => (
              <Option value={id}>{name}</Option>
            ))}{' '}
          </Select>
        );
      case 'inputbox':
        return (
          <MultiTextInputBox
            key={item?.val?.length} //To reset the element
            placeholder="Enter"
            defaultValue={item?.val}
            onUpdate={handelChangeItem(dataObj)}
          />
        );
    }
  };

  const footerTemplate = (dataObj) => () => {
    const handleApply = () => listenFilters(dataObj);

    return (
      <div style={flexEnd}>
        <PlusCircleOutlined onClick={handleAddFilter} style={styleAddFilter} />
        <Button type="default" onClick={handleFilterPopup}>
          Cancel
        </Button>{' '}
        &nbsp;
        <Button type="primary" onClick={handleApply} disabled={isDisable}>
          Apply
        </Button>
      </div>
    );
  };

  // 'Item' column Selectbox
  const handelSelectItem = (dataObj) => (args) => {
    let newData = JSON.parse(JSON.stringify(data));
    const itemIndex = newData?.findIndex(({ key }) => key === dataObj?.key);
    newData[itemIndex].item.val = args;
    setData(newData);
  };

  // 'Item' column Inputbox
  const handelChangeItem = (dataObj) => (value) => {
    console.log(value);
    let newData = JSON.parse(JSON.stringify(data));
    const itemIndex = newData?.findIndex(({ key }) => key === dataObj?.key);
    newData[itemIndex].item.val = value;
    setData(newData);
  };

  // 'Filter' column Selectbox
  const handleChangeFilter = (colData) => (value) => {
    let newData = JSON.parse(JSON.stringify(data));
    const itemIndex = newData?.findIndex(({ key }) => key === colData?.key);
    if (itemIndex == -1 || !newData[itemIndex]) return;
    newData[itemIndex].filter.val = value;
    // To set 'Item' column element
    switch (value) {
      case 'alertStatus':
        newData[itemIndex].item = {
          data: reviewStatusData,
          type: 'selectbox',
          val: []
        };
        break;
      case 'alertQuality':
        newData[itemIndex].item = {
          data: reviewFeedbackData,
          type: 'selectbox',
          val: []
        };
        break;
      case 'alertId':
      case 'runInstanceId':
      case 'runInstanceExecutionId':
        newData[itemIndex].item = { data: null, type: 'inputbox', val: [] };
        break;
      default:
        newData[itemIndex].item = { data: null, type: null, val: [] };
    }
    setData(newData);
  };

  const handleAddFilter = () => {
    if (data && data?.length === 5) return;
    let newData = [
      ...data,
      {
        key: count,
        logic: { data: [{ id: '=', name: 'equal to' }], val: '=' },
        filter: { data: null, val: null },
        item: { data: [], type: null, val: [] }
      }
    ];
    count++;
    setData(newData);
  };

  const handleRemoveFilter = (dataObj) => () => {
    let newData = JSON.parse(JSON.stringify(data));
    const filteredData = newData?.filter(({ key }) => key !== dataObj?.key);
    setData(filteredData);
  };

  return (
    <div style={{ minWidth: '300px' }}>
      <Table
        pagination={false}
        columns={columns}
        dataSource={data}
        bordered
        footer={footerTemplate(data)}
      />
    </div>
  );
};

Filter.defaultProps = defaultProps;
Filter.propTypes = {
  listenFilters: PropTypes.func
};
export default Filter;
